export enum SiteIssueType {
    SensorBatteryLow = 0,
    InconsistentBox = 1,
    SensorTamper = 2,
    SensorMissing = 3,
    BiometricDeviceUnavailable = 4,
    DmpPanelUnavailable = 5,
    DoorLeftOpen = 6,
    BoxLeftOpen = 7,
    HmiUnavailable = 8,
}
